/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import HandyIcon from "../../../assets/icons/traffic/toggleable/IconStrikethroughPhone";
import DrugsIcon from "../../../assets/icons/traffic/toggleable/IconAlcoholAndDrugs";
import ParkingIcon from "../../../assets/icons/traffic/toggleable/IconParkingBill";
import OtherIcon from "../../../assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "../../../services/translations/translations";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { FormDataTypes } from "../../../types/FormDataTypes";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";

export default function AccusationOther({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="accusationOther"
                question={translate("traffic.accusationOther.label", values)}
                options={[
                  {
                    labelText: translate("traffic.accusationOther.options.mobile_phone.label", values),
                    labelIcon: <HandyIcon />,
                    labelIconActive: <HandyIcon active />,
                    value: "mobile_phone",
                  },
                  {
                    labelText: translate("traffic.accusationOther.options.drugs.label", values),
                    labelIcon: <DrugsIcon />,
                    labelIconActive: <DrugsIcon active />,
                    value: "drugs",
                  },
                  {
                    labelText: translate("traffic.accusationOther.options.parking.label", values),
                    labelIcon: <ParkingIcon />,
                    labelIconActive: <ParkingIcon active />,
                    value: "parking",
                  },
                  {
                    labelText: translate("traffic.accusationOther.options.other.label", values),
                    labelIcon: <OtherIcon />,
                    labelIconActive: <OtherIcon active />,
                    value: "other",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
